module.exports = __webpack_public_path__ + "img/title-bg.41683065.png";